jQuery.fn.isVisible = function(offset) {
  const $window = jQuery(window);
  const $this = jQuery(this);
  const topView = $window.scrollTop();
  const botView = topView + $window.height();
  const topElement = $this.offset().top;
  const botElement = topElement + $this.height();
  return ((botElement <= botView + offset));
}

jQuery.fn.startTypeWritter = function() {
  jQuery(this).each((index, element) => {
    const $element = jQuery(element);
    $element.toggleClass('start', $element.isVisible(0));
  });
}

jQuery(document).ready(() => {

  const $typewritter = jQuery('.typewriter');

  $typewritter.startTypeWritter();
  jQuery('body').scroll(event => {
    $typewritter.startTypeWritter();
  });

});